<div class="list-popup">
    <div class="header">
        {{ data()?.length }} {{ headerText() }}
        @if (minPrice() !== maxPrice()) {
            <span>: {{ minPrice() }} - {{ maxPrice() }} mill </span>
        }
    </div>

    @if (sales().length > 1) {
        <div class="sort-wrapper">
            <div class="sort-wrapper-header">Sorter på</div>
            <div class="drop-down-wrapper">
                <ev-dropdown
                    class="filter-dropdown"
                    [items]="filterOptions()"
                    (onSelected)="setFilter($event)"
                    [minWidth]="'260'"
                    [selected]="selectedFilter()"
                    [right]="0"
                >
                </ev-dropdown>
            </div>
        </div>
    }
    <div class="item-wrapper">
        @for (sale of sales(); track $index) {
            <estate-sale-item [sale]="sale" (estateClicked)="onPopupClose()"></estate-sale-item>
        }
        <div class="bottom-margin"></div>
    </div>
</div>
